import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.find";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.number.constructor";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Sortable from 'sortablejs';
import ApiService from '@/services/apiService';
import iconsMixin from '@/components/core/dtwin/state/bridge/iconsMixin';
import dataSourcesListMixin from '@/components/core/dtwin/state/dataSourcesListMixin';
import { mapState } from 'vuex';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';
import 'codemirror/theme/duotone-light.css';
import 'codemirror/mode/javascript/javascript.js';
import { userItemsPerListMixin } from '@/utils/vuex';
import CoreDtwinStateEdit from '@/components/core/dtwin/state/edit';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
var defaultExportButton = {
  icon: 'fal fa-file-csv',
  action: 'exportModal',
  tooltip: 'Core.ExportDialog.titleTextCsv'
};
export default {
  name: 'CoreDtwinStateTable',
  components: {
    codemirror: codemirror,
    CoreDtwinStateEdit: CoreDtwinStateEdit
  },
  mixins: [iconsMixin, dataSourcesListMixin, userItemsPerListMixin],
  props: {
    // on the twin-overview page display just the bare minimum, without search and action buttons
    // options: null, lite, readonly, editonly
    mode: {
      type: String,
      required: false,
      default: function _default() {
        return null;
      }
    },
    tenantId: {
      type: Number,
      required: true
    },
    // the states that are to be displayed / edited
    value: {
      type: Array,
      required: true
    },
    updatedStates: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    hasTwinManagePermission: {
      type: Boolean,
      required: false,
      default: false
    },
    hasTwinEditPermission: {
      type: Boolean,
      required: false,
      default: false
    },
    deviceTemplate: {
      type: Object,
      required: false,
      default: null
    },
    isVirtualDevice: {
      type: Boolean,
      required: true
    },
    // the original twin(/virtual-device)-model
    // to be used by some components for additional requesting data
    twinModel: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    editDialogComponent: {
      type: String,
      required: false,
      default: function _default() {
        return 'core-dtwin-state-edit';
      }
    },
    exportButtonDetails: {
      type: Object,
      required: false,
      default: function _default() {
        return defaultExportButton;
      }
    },
    // optionally provide an own name-mapping for datasources
    sourcesNameMapping: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      showDeleteDialog: false,
      confirmDeleteId: null,
      linkedStateAggregations: null,
      blockStateOrdering: false,
      sortedStates: null,
      ruleType: null,
      bridgeConfigs: [],
      stateEditDialog: false,
      stateEditServerRequest: false,
      stateEditItem: null,
      stateNiotaImportDialog: false,
      // stateBulkCreateDialog: false,
      showHistoryDialog: false,
      historyState: null,
      search: '',
      stateDisplayDialog: false,
      cmOptions: {
        tabSize: 4,
        mode: 'application/ld+json',
        theme: this.$store.state.app.UiTheme ? 'base16-dark' : 'duotone-light',
        lineNumbers: false,
        line: true,
        foldGutter: true,
        styleActiveLine: true,
        styleSelectedText: true,
        readOnly: true,
        hintOptions: {
          completeSingle: false
        },
        lineWrapping: false,
        viewportMargin: Infinity,
        exportDialog: false
      },
      tableOptions: _objectSpread({}, defaultTableOptions)
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    themeMode: function themeMode() {
      return Boolean(this.$store.state.app.UiTheme) ? 'dark' : 'light';
    },
    getStateEditMode: function getStateEditMode() {
      if (this.isCreatedByTemplate) {
        return 'readonly';
      }

      if (!this.stateEditServerRequest && this.hasTwinEditPermission && this.mode !== 'readonly') {
        return this.stateEditItem == null ? 'create' : 'edit';
      } else {
        return 'readonly';
      }
    },
    detailButtonIcon: function detailButtonIcon() {
      return this.hasTwinEditPermission && this.mode !== 'readonly' ? 'fa-edit' : 'fa-eye';
    },
    actionButtons: function actionButtons() {
      if (this.mode === 'lite') {
        return [];
      }

      return [_objectSpread(_objectSpread({}, defaultExportButton), {}, {
        icon: get(this.exportButtonDetails, 'icon', defaultExportButton.icon),
        tooltip: this.$i18n_t(get(this.exportButtonDetails, 'tooltip', defaultExportButton.tooltip)),
        valid: this.value.length > 0 && this.$vuetify.breakpoint.smAndUp,
        'data-cy': 'csv_export_btn'
      }), {
        icon: 'fal fa-eye',
        action: 'stateView',
        valid: this.value.length > 0 && this.$vuetify.breakpoint.smAndUp,
        tooltip: this.$i18n_t('Common.viewDetails'),
        'data-cy': 'view_details_btn'
      }, this.mode === 'editonly' || this.mode === 'readonly' ? {} : {
        icon: 'fal fa-plus',
        action: 'addItem',
        disabled: this.isCreatedByTemplate,
        valid: !this.disabled && this.hasTwinEditPermission,
        tooltip: this.$i18n_t('Common.addNew'),
        dataCy: 'add_new_btn'
      }].filter(function (button) {
        return button.action;
      });
    },
    isCreatedByTemplate: function isCreatedByTemplate() {
      return !!this.deviceTemplate;
    },
    canDeleteState: function canDeleteState() {
      return this.linkedStateAggregations && this.linkedStateAggregations.length === 0;
    },
    tableLocalizations: function tableLocalizations() {
      return {
        dialogHeaders: [{
          text: ''
        }, {
          sortable: true,
          text: this.$i18n_t('Common.id'),
          value: 'id'
        }, {
          sortable: true,
          text: this.$i18n_t('DigitalTwin.DigitalTwin.states.title'),
          value: 'title'
        }, {
          sortable: true,
          text: this.$i18n_t('DigitalTwin.DigitalTwin.states.key'),
          value: 'key'
        }, {
          sortable: true,
          text: this.$i18n_t('DigitalTwin.DigitalTwin.states.value'),
          value: 'stateValue'
        }, {
          sortable: true,
          text: this.$i18n_t('DigitalTwin.DigitalTwin.states.unit'),
          value: 'unit'
        }, {
          sortable: true,
          text: this.$i18n_t('DigitalTwin.DigitalTwin.states.lastUpdate'),
          value: 'stateTime'
        }, {
          sortable: false,
          text: this.$i18n_t('DigitalTwin.DigitalTwin.states.source'),
          align: 'center'
        }, {
          text: ''
        }, {
          text: ''
        }],
        headers: [{
          sortable: false,
          text: '',
          align: 'right'
        }, {
          sortable: false,
          text: ''
        }, {
          sortable: false,
          text: this.$i18n_t('Common.id'),
          value: 'id'
        }, {
          sortable: false,
          text: this.$i18n_t('DigitalTwin.DigitalTwin.states.title'),
          value: 'title'
        }, {
          sortable: false,
          text: this.$i18n_t('DigitalTwin.DigitalTwin.states.value'),
          value: 'stateValue'
        }, {
          sortable: false,
          text: this.$i18n_t('DigitalTwin.DigitalTwin.states.unit'),
          value: 'unit'
        }, {
          sortable: false,
          text: this.$i18n_t('DigitalTwin.DigitalTwin.states.source'),
          align: 'center'
        }, {
          sortable: false,
          text: '',
          align: 'center'
        }, {
          sortable: false,
          text: '',
          align: 'center'
        }],
        dialogFooterProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [10, 20, 50]
        }
      };
    }
  }),
  watch: {
    updatedStates: function updatedStates() {
      var _this = this;

      if (this.historyState && this.updatedStates.findIndex(function (s) {
        return s.id === _this.historyState.id;
      }) >= 0) {
        if (this.$refs['dtwin-state-history']) {
          this.$refs['dtwin-state-history'].reloadData();
        }
      }
    },
    value: function value() {
      this.initSortableTable();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.tableOptions.itemsPerPage = this.savedUserItemsPerList();
    this.tableOptions.page = 1;
    this.$store.state.app.loading = true;
    this.initSortableTable();

    if (this.hasTwinEditPermission) {
      this.loadBridgeConfigs().then(function (configData) {
        var types = configData[0];
        var configs = configData[1];
        _this2.bridgeConfigs = configs.filter(function (config) {
          return get(_this2.bridgeConfig(config, types), 'manifest.functionScope.invokeDirection.inbound');
        }).map(function (config) {
          return {
            type: config.type,
            image: _this2.bridgeTypesIcons[config.type],
            title: config.name,
            configId: config.id,
            tenantId: config.tenantId
          };
        });
      }).catch(function (error) {
        console.error('Error', error);
      }).finally(function () {
        _this2.$store.state.app.loading = false;

        _this2.$emit('finishedLoading');
      });
    } else {
      this.$store.state.app.loading = false;
      this.$emit('finishedLoading');
    }
  },
  methods: {
    handlePagination: function handlePagination(options) {
      this.tableOptions.itemsPerPage = options.itemsPerPage;
      this.tableOptions.page = options.page;
    },
    isStateDeletable: function isStateDeletable(state) {
      return state.key !== '_raw' && state.key !== '_health' && state.key !== '_parsed' || !this.isVirtualDevice;
    },
    fetchLinkedStateAggregations: function fetchLinkedStateAggregations(stateId) {
      var _this3 = this;

      this.linkedStateAggregations = null;
      return ApiService.digitalTwinGetStateLinkedAggregations(this.$route.params.id, stateId).then(function (linkedStateAggregations) {
        linkedStateAggregations.forEach(function (state) {
          state.children = [_objectSpread(_objectSpread({}, state.dtwin), {}, {
            icon: state.dtwin.twinType === 'virtualDevice' ? 'sensor-on' : 'dice-d8',
            isTwin: true
          })];
          state.title = "".concat(state.title, " (").concat(state.key, ")");
          state.icon = state.icon || 'layer-group';
        });
        _this3.linkedStateAggregations = linkedStateAggregations;
      }).catch(function (error) {
        console.error(error);
      });
    },
    detailTableHeaderClasses: function detailTableHeaderClasses(props) {
      var sortBy = props.options.sortBy && props.options.sortBy.length ? props.options.sortBy[0] : 'none';
      var sortDesc = props.options.sortDesc && props.options.sortDesc.length && props.options.sortDesc[0];
      return {
        text: {
          title: sortBy === 'title' ? 'header-active' : 'header-nonactive',
          key: sortBy === 'key' ? 'header-active' : 'header-nonactive'
        },
        icon: {
          title: sortBy === 'title' ? sortDesc ? 'icon-desc' : '' : 'icon-nonactive',
          key: sortBy === 'key' ? sortDesc ? 'icon-desc' : '' : 'icon-nonactive'
        }
      };
    },
    detailTableHeaderColClass: function detailTableHeaderColClass(header, props) {
      var classes = ["text-".concat(header.align || 'start')];

      if (header.sortable) {
        classes.push('sortable');
      }

      var values = [header.value];

      if (header.value === 'title') {
        values.push('key');
      }

      if (props.options.sortBy && props.options.sortBy.length && values.indexOf(props.options.sortBy[0]) >= 0) {
        classes.push('active');

        if (props.options.sortDesc && props.options.sortDesc.length && props.options.sortDesc[0]) {
          classes.push('desc');
        } else {
          classes.push('asc');
        }
      }

      return classes.join(' ');
    },
    updateStatesOrder: function updateStatesOrder() {
      var _this4 = this;

      var orderArray = this.sortedStates.map(function (item) {
        return item.id;
      });
      var twinId = this.$route.params.id;
      ApiService.digitalTwinUpdateStatesOrder(this, twinId, orderArray).then(function () {
        _this4.$emit('statesUpdated');

        _this4.blockStateOrdering = false;
      }).catch(function (error) {
        console.error(error);
      });
    },
    initSortableTable: function initSortableTable() {
      var _this5 = this;

      var table = document.querySelector('.states-table tbody');
      this.sortedStates = cloneDeep(this.value);
      Sortable.create(table, {
        handle: '.handle',
        onEnd: function onEnd(_ref) {
          var _this5$sortedStates;

          var newIndex = _ref.newIndex,
              oldIndex = _ref.oldIndex;
          var pageOffset = (_this5.tableOptions.page - 1) * _this5.tableOptions.itemsPerPage;
          _this5.blockStateOrdering = true;

          (_this5$sortedStates = _this5.sortedStates).splice.apply(_this5$sortedStates, [newIndex + pageOffset, 0].concat(_toConsumableArray(_this5.sortedStates.splice(oldIndex + pageOffset, 1))));

          _this5.updateStatesOrder();
        }
      });
    },
    bridgeConfig: function bridgeConfig(bridge, types) {
      var foundMatch = types.find(function (config) {
        return config.type === bridge.type;
      });
      return foundMatch;
    },
    loadBridgeConfigs: function loadBridgeConfigs() {
      return Promise.all([ApiService.getBridgeTypes(), ApiService.getBridgesForTenant(this.tenantId)]);
    },
    editState: function editState(item) {
      if (this.mode === 'lite' && this.mode === 'readonly' || this.disabled) {
        // no editing in lite-view
        return;
      }

      if (!item.properties.binding.options) {
        item.properties.binding = Object.assign({}, item.properties.binding, {
          options: {}
        });
      }

      if ((item.properties.binding.options.aggregateStateBindingIds || []).length === 0) {
        item.properties.binding.options = Object.assign({}, item.properties.binding.options, {
          aggregateStateBindingIds: []
        });
      }

      this.stateEditItem = item;
      this.stateEditDialog = true;
    },
    localizeDate: function localizeDate(item) {
      if (item.value && item.value.time) {
        moment.locale(this.$store.state.app.language || window.navigator.userLanguage || window.navigator.language);
        return moment(item.value.time).format('L LTS');
      }

      return '-';
    },
    // addStack () {
    //   this.stateBulkCreateDialog = true
    // },
    addItem: function addItem() {
      this.openStateEditForm();
    },
    stateView: function stateView() {
      this.stateDisplayDialog = true;
    },
    exportModal: function exportModal() {
      this.$emit('showExportModal');
    },
    outputValue: function outputValue(item) {
      if (item.value === null || item.value.value === null) {
        return 'null';
      }

      try {
        var jsonObject = _typeof(item.value.value) === 'object' ? item.value.value : JSON.parse(item.value.value); // parse and then stringify again to get a nice format

        return JSON.stringify(jsonObject, null, 1);
      } catch (error) {// on error we return outside of try/catch
      }

      return item.value.value || 'null';
    },
    displayType: function displayType(item) {
      if (typeof item.value.value === 'string') {
        if (item.value.value.length > 50) {
          return 'code';
        }
      }

      if (item.value === null || item.value.value === null) {
        return 'plain';
      }

      if (_typeof(item.value.value) === 'object' || item.properties.valueType === 'json') {
        return 'code';
      }

      return 'plain';
    },
    openStateEditForm: function openStateEditForm() {
      this.stateEditItem = null;
      this.stateEditDialog = true;
    },
    openNiotaImportForm: function openNiotaImportForm() {
      this.stateNiotaImportDialog = true;
    },
    closeEditWithError: function closeEditWithError(errorMessage) {
      if (errorMessage) {
        this.$snack(errorMessage, 'error');
      }

      this.stateEditDialog = false;
      this.stateEditItem = null;
    },
    saveState: function saveState(stateDetails) {
      var _this6 = this;

      stateDetails.dtwinId = this.$route.params.id;
      var serverProcessingPromise = null;

      if (stateDetails.value.value === undefined) {
        stateDetails.value.value = null;
      }

      this.stateEditServerRequest = true;

      if (!stateDetails.id) {
        serverProcessingPromise = ApiService.digitalTwinCreateState(this, stateDetails).then(function () {
          _this6.$emit('statesUpdated');

          _this6.$snack(_this6.$i18n_t('DigitalTwin.DigitalTwin.states.created') + stateDetails.properties.title, 'success');

          _this6.stateEditDialog = false;
        });
      } else {
        serverProcessingPromise = ApiService.digitalTwinUpdateState(this, stateDetails).then(function () {
          _this6.$emit('statesUpdated');

          _this6.$snack(_this6.$i18n_t('DigitalTwin.DigitalTwin.states.updated') + stateDetails.properties.title, 'success');

          _this6.stateEditDialog = false;
        });
      }

      serverProcessingPromise.catch(function (error) {
        var responseMsg = get(error, 'response.data.message');

        if (_this6.$i18n_t("Error.".concat(error.response.data.message))) {
          _this6.$snack(_this6.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          var outputErrorMsg = "".concat(_this6.$i18n_t("DigitalTwin.DigitalTwin.states.".concat(stateDetails.id ? 'update' : 'create', "Error")));

          if (responseMsg) {
            outputErrorMsg = "".concat(outputErrorMsg, ": ").concat(responseMsg);
          }

          _this6.$snack(outputErrorMsg, 'error');
        }
      }).finally(function () {
        _this6.stateEditServerRequest = false;
      });
    },
    deleteState: function deleteState(id) {
      this.fetchLinkedStateAggregations(id);
      this.confirmDeleteId = id;
      this.showDeleteDialog = true;
    },
    handleConfirmDelete: function handleConfirmDelete(id) {
      var _this7 = this;

      this.confirmDeleteId = null;
      var state = this.value.find(function (state) {
        return state.id === id;
      });

      if (state) {
        ApiService.digitalTwinDeleteState(this, state.dtwinId, id).then(function () {
          _this7.$emit('statesUpdated');

          _this7.$snack(_this7.$i18n_t('DigitalTwin.DigitalTwin.states.deleted') + state.properties.title, 'success');
        }).catch(function (error) {
          if (error.response && _this7.$i18n_t("Error.".concat(error.response.data.message))) {
            _this7.$snack(_this7.$i18n_t("Error.".concat(error.response.data.message)), 'error');
          } else {
            _this7.$snack('Could not delete state', 'error');
          }
        });
      }
    },
    importNiota: function () {
      var _importNiota = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(deviceVariableImport) {
        var _this8 = this;

        var states;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.stateNiotaImportDialog = false;
                states = deviceVariableImport.variables.map(function (variable) {
                  return {
                    key: variable.key,
                    dtwinId: _this8.$route.params.id,
                    value: {
                      value: variable.value,
                      time: variable.time
                    },
                    properties: {
                      title: variable.key,
                      unit: variable.unit,
                      binding: {
                        type: 'bridge',
                        options: {
                          configId: deviceVariableImport.configId,
                          identifier: deviceVariableImport.identifier,
                          variable: variable.key
                        }
                      }
                    }
                  };
                });
                _context.next = 4;
                return this.createStates(states);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function importNiota(_x) {
        return _importNiota.apply(this, arguments);
      }

      return importNiota;
    }(),
    createStates: function () {
      var _createStates = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(states) {
        var _this9 = this;

        var _loop, i;

        return regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop(i) {
                  return regeneratorRuntime.wrap(function _loop$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return ApiService.digitalTwinCreateState(_this9, states[i]).then(function () {
                            _this9.$emit('statesUpdated');

                            _this9.$snack(_this9.$i18n_t('DigitalTwin.DigitalTwin.states.created') + states[i].properties.title, 'success');
                          }).catch(function (error) {
                            var responseMsg = get(error, 'response.data.message');

                            if (_this9.$i18n_t("Error.".concat(error.response.data.message))) {
                              _this9.$snack(_this9.$i18n_t("Error.".concat(error.response.data.message)), 'error');
                            } else {
                              var createErrorMsg = "".concat(_this9.$i18n_t('DigitalTwin.DigitalTwin.states.createError'), ": ").concat(states[i].properties.title);

                              if (responseMsg) {
                                createErrorMsg = "".concat(createErrorMsg, ": ").concat(responseMsg);
                              }

                              _this9.$snack(createErrorMsg, 'error');
                            }
                          });

                        case 2:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _loop);
                });
                i = 0;

              case 2:
                if (!(i < states.length)) {
                  _context3.next = 7;
                  break;
                }

                return _context3.delegateYield(_loop(i), "t0", 4);

              case 4:
                i++;
                _context3.next = 2;
                break;

              case 7:
                this.$emit('statesUpdated');

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee2, this);
      }));

      function createStates(_x2) {
        return _createStates.apply(this, arguments);
      }

      return createStates;
    }(),
    showHistory: function showHistory(a) {
      this.historyState = a;
      this.showHistoryDialog = true;
    }
  }
};